import totalIncidents from '../../../assets/icons/TotalIncidentIcon.svg';
import spendingHour from "../../../assets/icons/SpendingHourIcon.svg";
import CatStatsCard from './CatStatsCard';
import LearnerUtilizationChart from './charts/LearnerUtilizationChart';
import MappedIncidentChart from './charts/MappedIncidentChart';
import CataloguesBarchart from './charts/CataloguesBarchart';
import { useNavigate } from 'react-router-dom';
import { useCallback, useContext, useEffect, useState } from 'react';
import AuthContext from '../../../auth/AuthContext';
import CatalogueService from '../../../services/CatalogueService';
import AlertService from '../../../services/AlertService';

const CatalogueDashboard = () => {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(true);

  const catalogueAccess = authContext.getPermissions("cataloguedashboard");
  const showAdd = catalogueAccess.some(f => f.access.includes(2));

 const loadDashboard = useCallback(async (signal) => { 
    setLoading(true);
    try {
      const data = await CatalogueService.GetIncidentDashboard(
        authContext,
        signal 
      );

      if (signal?.aborted) return; 

      if (data.isSuccess) {
        setCardData([
          { title: "Total Incidents", value: data.data.totalIncidents, icon: totalIncidents, bgColor: "#DFF2FF" },
          { title: "Total Learning Hours", value: data.data.spendingHours, icon: spendingHour, bgColor: "#f5d087c4" },
        ]);
      } else {
        AlertService.error(data.errorMessage);
      }
    } catch (err) {
      if (err.name === "AbortError") return; 
      AlertService.error("Failed to load dashboard data");
      console.error(err);
    } finally {
      if (!signal?.aborted) setLoading(false); 
    }
  }, [authContext]);

useEffect(() => {
    const controller = new AbortController();
    loadDashboard(controller.signal);
    return () => controller.abort();
  }, [loadDashboard]);

  return (
    <div className="container-fluid mt-2 pb-3">
      {/* Header buttons */}
      <div className="d-flex justify-content-end gap-3 mb-3">
        <button
          className="btn btn-primary py-2 px-md-4"
          onClick={() => navigate('/catalogue-dashboard/catalogue')}
        >
          Repository
        </button>
        {showAdd && (
          <button
            className="btn btn-primary py-2 px-md-4"
            onClick={() => navigate('/catalogue-dashboard/catalogue-mapping')}
          >
            Mapping
          </button>
        )}
      </div>

      <div className="row g-3 align-items-stretch mb-3">
        <div className={`col-xl-${showAdd ? "4" : "6"} col-lg-6 col-md-12`}>
          <div className="row g-3">
            {(loading ? Array.from({ length: 2 }) : cardData).map((card, idx) => (
              <div key={idx} className="col-12">
                <CatStatsCard {...card} loading={loading} />
              </div>
            ))}
          </div>
        </div>

        {showAdd ? (
          <>
            <div className="col-xl-4 col-lg-6 col-md-12">
              <div className="h-100">
                <MappedIncidentChart />
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-md-12">
              <div className="h-100">
                <LearnerUtilizationChart />
              </div>
            </div>
          </>
        ) : (
          <div className="col-xl-6 col-lg-6 col-md-12">
            <div className="h-100">
              <CataloguesBarchart />
            </div>
          </div>
        )}
      </div>


      {showAdd && (
        <div className="row g-3 align-items-stretch">
          <div className="col-xl-6 col-md-12">
            <CataloguesBarchart />
          </div>
        </div>
      )}
    </div>
  );
};

export default CatalogueDashboard;
